import * as THREE from 'three';

export default class EffectShell {
	constructor(container = document.body, itemsWrapper = null, store = null) {
		this.container = container;
		this.itemsWrapper = itemsWrapper;
		this.store = store;
		if(!this.container || !this.itemsWrapper || !this.store) return;
		
		this.setup();
		this.initEffectShell().then( ()=> {
			//console.log('load finished');
			this.isLoaded = true;
		});

		this.createEventsListeners();
	}

	setup() {
		window.addEventListener('resize', this.onWindowResize.bind(this), false);

		// Renderer
		this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true});
		this.renderer.setSize(this.viewport.width, this.viewport.height);
		this.renderer.setPixelRatio = window.devicePixelRatio;
		this.container.appendChild(this.renderer.domElement);

		// Scene
		this.scene = new THREE.Scene();

		// Camera
		this.camera = new THREE.PerspectiveCamera(
			40,
			this.viewport.aspectRatio,
			0.1,
			100
		)
		this.camera.position.set(0, 0, 3);

		// Mouse
		this.mouse = new THREE.Vector2();

		// Time
		this.timeSpeed = 2;
		this.time = 0;
		this.clock = new THREE.Clock();

		// Animation Loop
		this.time += this.clock.getDelta() * this.timeSpeed;
		this.renderer.setAnimationLoop(this.render.bind(this));
	}

	render() {
		// Called every frame
		this.renderer.render(this.scene, this.camera);
	}	

	onWindowResize() {
		this.camera.aspect = this.viewport.aspectRatio;
		this.camera.updateProjectionMatrix();
		this.renderer.setSize(this.viewport.width, this.viewport.height);
	}
	

	// Async operation -- Load textures via Three TextureLoader after images are first loaded
	initEffectShell() {
		let promises = [];
		this.items = this.itemsElements;				

		const THREEtextureLoader = new THREE.TextureLoader();
		this.items.forEach((item, index) => {					
			// Create Textures
			promises.push(
				this.loadTexture(
					THREEtextureLoader,
					item.img ? item.img : null,
					index
				)				
			);			
		});		
	
		//console.log(promises);

		return new Promise((resolve, reject) => {
			// Resolve texture promieses
			Promise.all(promises).then(promises => {

				// All textures are now loaded
				promises.forEach((promise, index) => {
					// Assign each promies to a texture
					this.items[index].texture = promise.texture;					
				});

				resolve();
			});

			let dev = false
			if(dev)
				console.log(reject);
		});
	}

	loadTexture(loader, url, index) {
		// https://threejs.org/docs/#api/en/loaders/TextureLoader
		return new Promise((resolve, reject) => {
			if(!url) {
				resolve({ texture: null, index });
				return;
			}

			// Load a resource
			loader.load(
				// resource URL
				url,

				// onLoad callback
				texture => {
					resolve({texture, index});					
				},

				// onProgress callback currently not supported
				undefined,

				// onError callback
				error => {
					console.error('An error happened. ', error)
					reject(error);
				}
			);			
		});
	}

	// Events
	createEventsListeners() {				
		this.items.forEach((item, index) => {				
			item.element.addEventListener(
				'mouseover',
				this._onMouseOver.bind(this, index),
				false
			);

			/*item.element.addEventListener(
				'click',
				this._onMouseClick.bind(this, index),
				false
			);*/
		});

		this.container.addEventListener(
			'mousemove',
			this._onMouseMove.bind(this),
			false
		);

		this.itemsWrapper.addEventListener(
			'mouseleave',
			this._onMouseLeave.bind(this),
			false
		);
	}

	_onMouseLeave(event) {
		this.isMouseOver = false;
		this.onMouseLeave(event);
	}

	_onMouseMove(event) {
		// Get normalized mouse position on viewport		
		this.mouse.x = (event.clientX / this.viewport.width) * 2 - 1;
		this.mouse.y = -( (event.clientY + window.pageYOffset) / this.viewport.height) * 2 + 1;		

		this.onMouseMove(event);
	}

	_onMouseOver(index, event) {
		this.onMouseOver(index, event);
	}

	/*_onMouseClick(index, event) {
		this.onMouseClick(index, event);
	}*/

	get viewport() {
		let width = this.container.clientWidth;
		let height = this.container.clientHeight;
		let aspectRatio = width / height;		

		return {
			width,
			height,
			aspectRatio
		}
	}

	// Grab images from DOM
	get itemsElements() {
		// Convert NodeList to Array
		const items = [...this.itemsWrapper.querySelectorAll('.work-link')]		

		// Create Array of items including element, image and index
		return items.map((item, index) => ({
			element: item,
			img: require('../assets/' + this.store[index].img) || null,
			index: index
		}))
	}

	get viewSize() {
		// Fit Plane to screen
		// https://gist.github.com/ayamflow/96a1f554c3f88eef2f9d0024fc42940f
		
		let distance = this.camera.position.z
		let vFov = (this.camera.fov * Math.PI) / 180
		let height = 2 * Math.tan(vFov / 2) * distance
		let width = height * this.viewport.aspectRatio
		return { width, height, vFov }
	}
}